import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ScribensPluginCommand from './plugincommand';
import ScribensPluginUI from './pluginui';
import '../dist/main';
import '../theme/styles.css';

export default class ScribensPlugin extends Plugin {
  static get requires() {
    return [ScribensPluginCommand, ScribensPluginUI];
  }

	static get pluginName() {
		return 'ScribensPlugin';
	}
}